// Áttekintő képernyő szerződés csempe láthatóságát vezérlő státuszok listája.
export const ContractInvisibleStatusesList = [
  "UNDER_EDITING", // Fióki rögzítés alatt
  "VERIFICATION_JBPM_PROCESS_STARTING", // Verifikációra vár (folyamatindítás)
  "VERIFICATION_JBPM_PROCESS_STARTED", // Verifikációra vár
  "VERIFICATION", // Verifikáció alatt
  "OPERATIONAL_DECISION_JBPM_PROCESS_STARTING", // Operációs döntésre vár (folyamatindítás)
  "OPERATIONAL_DECISION_JBPM_PROCESS_STARTED", // Operációs döntésre vár
  "OPERATIONAL_DECISION", // Operációs döntés alatt
  "RECTIFICATION_JBPM_PROCESS_STARTING", // Hiánypótlásra vár (folyamatindítás)
  "RECTIFICATION_JBPM_PROCESS_STARTED", // Hiánypótlásra vár
  "RECTIFICATION", // Hiánypótlás alatt
  "RISK_DECISION_JBPM_PROCESS_STARTING", // Risk döntésre vár (folyamatindítás)
  "RISK_DECISION_JBPM_PROCESS_STARTED", // Risk döntésre vár
  "RISK_DECISION", // Risk döntés alatt
  "DECISION_PROCESSING_JBPM_PROCESS_STARTING", // Döntés feldolgozásra vár (folyamatindítás)
  "DECISION_PROCESSING_JBPM_PROCESS_STARTED", // Döntés feldolgozásra vár
  "DECISION_PROCESSING", // Döntés feldolgozás alatt
  "CONTRACTING_JBPM_PROCESS_STARTING", // Szerződéskötésre vár (folyamatindítás)
  "CONTRACTING_JBPM_PROCESS_STARTED", // Szerződéskötésre vár
  "CONTRACTING", // Szerződéskötés alatt
  "DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTING", // Döntés felülvizsgálat ellenőrzésre vár (folyamatindítás)
  "DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTED", // Döntés felülvizsgálat ellenőrzésre vár
  "DECISION_REVIEW_CHECK", // Döntés felülvizsgálat ellenőrzése alatt
  "DECISION_REVIEW_JBPM_PROCESS_STARTING", // Döntés felülvizsgálat ellenőrzésre vár (folyamatindítás)
  "DECISION_REVIEW_JBPM_PROCESS_STARTED", // Döntés felülvizsgálat ellenőrzésre vár
  "DECISION_REVIEW", // Döntés felülvizsgálat ellenőrzése alatt
  "FAILED_JBPM_PROCESS_STARTING", // Meghiúsulásra vár (folyamatindítás)
  "FAILED_JBPM_PROCESS_STARTED", // Meghiúsulásra vár
  "FAILED", // Meghiúsult
  "REJECTED_JBPM_PROCESS_STARTING", // Elutasításra vár (folyamatindítás)
  "REJECTED_JBPM_PROCESS_STARTED", // Elutasításra vár
  "REJECTED", // Elutasítva
  "CLOSED", // Lezárt
  "SZK_CHECK_ASSIGN_BRANCH_AUTO_JBPM_PROCESS_STARTING",
  "SZK_CHECK_ASSIGN_BRANCH_AUTO",
  "SZK_ASSIGN_TO_BRANCH_JBPM_PROCESS_STARTING",
  "SZK_ASSIGN_TO_BRANCH_JBPM_PROCESS_STARTED",
  "SZK_ASSIGN_TO_BRANCH",
  "SZK_CHECK_CREATE_CUSTOMER_AUTO_JBPM_PROCESS_STARTING",
  "SZK_CHECK_CREATE_CUSTOMER_AUTO",
  "SZK_CREATE_CUSTOMER_JBPM_PROCESS_STARTING",
  "SZK_CREATE_CUSTOMER_JBPM_PROCESS_STARTED",
  "SZK_CREATE_CUSTOMER",
  "SZK_CHECK_CUSTOMER_DATA_AUTO_JBPM_PROCESS_STARTING",
  "SZK_CHECK_CUSTOMER_DATA_AUTO",
  "SZK_UPDATE_SAP_JBPM_PROCESS_STARTING",
  "SZK_UPDATE_SAP_JBPM_PROCESS_STARTED",
  "SZK_UPDATE_SAP",
  "SZK_UNDER_EDITING_JBPM_PROCESS_STARTING",
  "SZK_UNDER_EDITING_JBPM_PROCESS_STARTED",
  "SZK_UNDER_EDITING",
  "SZK_VERIFICATION_JBPM_PROCESS_STARTING",
  "SZK_VERIFICATION_JBPM_PROCESS_STARTED",
  "SZK_VERIFICATION",
  "SZK_OPERATIONAL_DECISION_JBPM_PROCESS_STARTING",
  "SZK_OPERATIONAL_DECISION_JBPM_PROCESS_STARTED",
  "SZK_OPERATIONAL_DECISION",
  "SZK_RISK_DECISION_JBPM_PROCESS_STARTING",
  "SZK_RISK_DECISION_JBPM_PROCESS_STARTED",
  "SZK_RISK_DECISION",
  "SZK_RECTIFICATION_JBPM_PROCESS_STARTING",
  "SZK_RECTIFICATION_JBPM_PROCESS_STARTED",
  "SZK_RECTIFICATION",
  "SZK_CONTRACTING_JBPM_PROCESS_STARTING",
  "SZK_CONTRACTING_JBPM_PROCESS_STARTED",
  "SZK_CONTRACTING",
  "SZK_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTING",
  "SZK_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTED",
  "SZK_DECISION_REVIEW_CHECK",
  "SZK_DECISION_REVIEW_JBPM_PROCESS_STARTING",
  "SZK_DECISION_REVIEW_JBPM_PROCESS_STARTED",
  "SZK_DECISION_REVIEW",
  "SZK_DECISION_REVIEW_VERIF_JBPM_PROCESS_STARTING",
  "SZK_DECISION_REVIEW_VERIF_JBPM_PROCESS_STARTED",
  "SZK_DECISION_REVIEW_VERIF",
  "SZK_FAILED_JBPM_PROCESS_STARTING",
  "SZK_FAILED_JBPM_PROCESS_STARTED",
  "SZK_FAILED",
  "SZK_REJECTED_JBPM_PROCESS_STARTING",
  "SZK_REJECTED_JBPM_PROCESS_STARTED",
  "SZK_REJECTED",
  "ASZK_ASSIGN_TO_BRANCH",
  "ASZK_ASSIGN_TO_BRANCH_JBPM_PROCESS_STARTED",
  "ASZK_ASSIGN_TO_BRANCH_JBPM_PROCESS_STARTING",
  "ASZK_CHECK_ASSIGN_BRANCH_AUTO",
  "ASZK_CHECK_ASSIGN_BRANCH_AUTO_JBPM_PROCESS_STARTING",
  "ASZK_CHECK_CREATE_CUSTOMER_AUTO",
  "ASZK_CHECK_CREATE_CUSTOMER_AUTO_JBPM_PROCESS_STARTING",
  "ASZK_CHECK_CUSTOMER_DATA_AUTO",
  "ASZK_CHECK_CUSTOMER_DATA_AUTO_JBPM_PROCESS_STARTING",
  "ASZK_CONTRACTING",
  "ASZK_CONTRACTING_JBPM_PROCESS_STARTED",
  "ASZK_CONTRACTING_JBPM_PROCESS_STARTING",
  "ASZK_CREATE_CUSTOMER",
  "ASZK_CREATE_CUSTOMER_JBPM_PROCESS_STARTED",
  "ASZK_CREATE_CUSTOMER_JBPM_PROCESS_STARTING",
  "ASZK_DECISION_REVIEW",
  "ASZK_DECISION_REVIEW_CHECK",
  "ASZK_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTED",
  "ASZK_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTING",
  "ASZK_DECISION_REVIEW_JBPM_PROCESS_STARTED",
  "ASZK_DECISION_REVIEW_JBPM_PROCESS_STARTING",
  "ASZK_DECISION_REVIEW_VERIF",
  "ASZK_DECISION_REVIEW_VERIF_JBPM_PROCESS_STARTED",
  "ASZK_DECISION_REVIEW_VERIF_JBPM_PROCESS_STARTING",
  "ASZK_FAILED",
  "ASZK_FAILED_JBPM_PROCESS_STARTED",
  "ASZK_FAILED_JBPM_PROCESS_STARTING",
  "ASZK_OPERATIONAL_DECISION",
  "ASZK_OPERATIONAL_DECISION_JBPM_PROCESS_STARTED",
  "ASZK_OPERATIONAL_DECISION_JBPM_PROCESS_STARTING",
  "ASZK_RECTIFICATION",
  "ASZK_RECTIFICATION_JBPM_PROCESS_STARTED",
  "ASZK_RECTIFICATION_JBPM_PROCESS_STARTING",
  "ASZK_REJECTED",
  "ASZK_REJECTED_JBPM_PROCESS_STARTED",
  "ASZK_REJECTED_JBPM_PROCESS_STARTING",
  "ASZK_RISK_DECISION",
  "ASZK_RISK_DECISION_JBPM_PROCESS_STARTED",
  "ASZK_RISK_DECISION_JBPM_PROCESS_STARTING",
  "ASZK_UNDER_EDITING",
  "ASZK_UNDER_EDITING_JBPM_PROCESS_STARTED",
  "ASZK_UNDER_EDITING_JBPM_PROCESS_STARTING",
  "ASZK_UPDATE_SAP",
  "ASZK_UPDATE_SAP_JBPM_PROCESS_STARTED",
  "ASZK_UPDATE_SAP_JBPM_PROCESS_STARTING",
  "ASZK_VERIFICATION",
  "ASZK_VERIFICATION_JBPM_PROCESS_STARTED",
  "ASZK_VERIFICATION_JBPM_PROCESS_STARTING",
  "BSZK_ASSIGN_TO_BRANCH",
  "BSZK_ASSIGN_TO_BRANCH_JBPM_PROCESS_STARTED",
  "BSZK_ASSIGN_TO_BRANCH_JBPM_PROCESS_STARTING",
  "BSZK_CHECK_ASSIGN_BRANCH_AUTO",
  "BSZK_CHECK_ASSIGN_BRANCH_AUTO_JBPM_PROCESS_STARTING",
  "BSZK_CHECK_CREATE_CUSTOMER_AUTO",
  "BSZK_CHECK_CREATE_CUSTOMER_AUTO_JBPM_PROCESS_STARTING",
  "BSZK_CHECK_CUSTOMER_DATA_AUTO",
  "BSZK_CHECK_CUSTOMER_DATA_AUTO_JBPM_PROCESS_STARTING",
  "BSZK_CREATE_CUSTOMER",
  "BSZK_CREATE_CUSTOMER_JBPM_PROCESS_STARTED",
  "BSZK_CREATE_CUSTOMER_JBPM_PROCESS_STARTING",
  "BSZK_DECISION_REVIEW",
  "BSZK_DECISION_REVIEW_CHECK",
  "BSZK_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTED",
  "BSZK_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTING",
  "BSZK_DECISION_REVIEW_JBPM_PROCESS_STARTED",
  "BSZK_DECISION_REVIEW_JBPM_PROCESS_STARTING",
  "BSZK_DECISION_REVIEW_VERIF",
  "BSZK_DECISION_REVIEW_VERIF_JBPM_PROCESS_STARTED",
  "BSZK_DECISION_REVIEW_VERIF_JBPM_PROCESS_STARTING",
  "BSZK_FAILED",
  "BSZK_FAILED_JBPM_PROCESS_STARTED",
  "BSZK_FAILED_JBPM_PROCESS_STARTING",
  "BSZK_OPERATIONAL_DECISION",
  "BSZK_OPERATIONAL_DECISION_JBPM_PROCESS_STARTED",
  "BSZK_OPERATIONAL_DECISION_JBPM_PROCESS_STARTING",
  "BSZK_RECTIFICATION",
  "BSZK_RECTIFICATION_JBPM_PROCESS_STARTED",
  "BSZK_RECTIFICATION_JBPM_PROCESS_STARTING",
  "BSZK_REJECTED",
  "BSZK_REJECTED_JBPM_PROCESS_STARTED",
  "BSZK_REJECTED_JBPM_PROCESS_STARTING",
  "BSZK_RISK_DECISION",
  "BSZK_RISK_DECISION_JBPM_PROCESS_STARTED",
  "BSZK_RISK_DECISION_JBPM_PROCESS_STARTING",
  "BSZK_UNDER_EDITING",
  "BSZK_UNDER_EDITING_JBPM_PROCESS_STARTED",
  "BSZK_UNDER_EDITING_JBPM_PROCESS_STARTING",
  "BSZK_UPDATE_SAP",
  "BSZK_UPDATE_SAP_JBPM_PROCESS_STARTED",
  "BSZK_UPDATE_SAP_JBPM_PROCESS_STARTING",
  "BSZK_VERIFICATION",
  "BSZK_VERIFICATION_JBPM_PROCESS_STARTED",
  "BSZK_VERIFICATION_JBPM_PROCESS_STARTING",
  "PAL_CUSTOMER_DATA_RECORDING",
  "PAL_EVALUATION_AUTO_JBPM_PROCESS_STARTING",
  "PAL_EVALUATION_AUTO",
  "PAL_CLAIM_SUBMISSION_JBPM_PROCESS_STARTING",
  "PAL_CLAIM_SUBMISSION",
  "BIA_UNDER_EDITING",
  "BIA_VERIFICATION_JBPM_PROCESS_STARTING",
  "BIA_VERIFICATION_JBPM_PROCESS_STARTED",
  "BIA_VERIFICATION",
  "BIA_RISK_DECISION_JBPM_PROCESS_STARTING",
  "BIA_RISK_DECISION_JBPM_PROCESS_STARTED",
  "BIA_RISK_DECISION",
  "BIA_FAILED_JBPM_PROCESS_STARTING",
  "BIA_FAILED_JBPM_PROCESS_STARTED",
  "BIA_FAILED",
  "BIA_RECTIFICATION_JBPM_PROCESS_STARTING",
  "BIA_RECTIFICATION_JBPM_PROCESS_STARTED",
  "BIA_RECTIFICATION",
  "BIA_REJECTED_JBPM_PROCESS_STARTING",
  "BIA_REJECTED_JBPM_PROCESS_STARTED",
  "BIA_REJECTED",
  "BIA_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTING",
  "BIA_DECISION_REVIEW_CHECK_JBPM_PROCESS_STARTED",
  "BIA_DECISION_REVIEW_CHECK",
  "BIA_DECISION_REVIEW_JBPM_PROCESS_STARTING",
  "BIA_DECISION_REVIEW_JBPM_PROCESS_STARTED",
  "BIA_DECISION_REVIEW",
]

// Valamilyen hiba folytán meghiúsult / lezárt ügyletek státuszainak listája (Dashboard / Cases komponensben szűréshez használt)
export const ClosedCaseTypeList = [
  "CLOSED",
  "FAILED",
  "FAILED_JBPM_PROCESS_STARTED",
  "FAILED_JBPM_PROCESS_STARTING",
  "REJECTED",
  "REJECTED_JBPM_PROCESS_STARTED",
  "REJECTED_JBPM_PROCESS_STARTING",
  "SZK_REJECTED_JBPM_PROCESS_STARTING",
  "SZK_REJECTED_JBPM_PROCESS_STARTED",
  "SZK_REJECTED",
  "SZK_FAILED_JBPM_PROCESS_STARTING",
  "SZK_FAILED_JBPM_PROCESS_STARTED",
  "SZK_FAILED",
  "ASZK_FAILED",
  "ASZK_FAILED_JBPM_PROCESS_STARTED",
  "ASZK_FAILED_JBPM_PROCESS_STARTING",
  "ASZK_REJECTED",
  "ASZK_REJECTED_JBPM_PROCESS_STARTED",
  "ASZK_REJECTED_JBPM_PROCESS_STARTING",
  "BSZK_FAILED",
  "BSZK_FAILED_JBPM_PROCESS_STARTED",
  "BSZK_FAILED_JBPM_PROCESS_STARTING",
  "BSZK_REJECTED",
  "BSZK_REJECTED_JBPM_PROCESS_STARTED",
  "BSZK_REJECTED_JBPM_PROCESS_STARTING",
  "BIA_FAILED_JBPM_PROCESS_STARTING",
  "BIA_FAILED_JBPM_PROCESS_STARTED",
  "BIA_FAILED",
  "BIA_REJECTED_JBPM_PROCESS_STARTING",
  "BIA_REJECTED_JBPM_PROCESS_STARTED",
  "BIA_REJECTED",
]

// Minden ügylet státusz ami az ügyfél szempontjából sikeres / folyosítva lett státusz lista (Dashboard / Cases komponensben szűrésre és badge színezésre használva)
export const SuccessCaseTypeList = [
  "ACTIVE",
  "ACTIVE_JBPM_PROCESS_STARTED",
  "ACTIVE_JBPM_PROCESS_STARTING",
  "ANNUAL_REVISION",
  "COLLATERAL_MODIFICATION",
  "COMPLEX_EVENT",
  "CUSTOMER_GROUP_RECORDING",
  "CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTING",
  "DATA_MODIFICATION",
  "GUARANTEE_RECORDING_AUTO",
  "GUARANTEE_RECORDING_AUTO_JBPM_PROCESS_STARTING",
  "GUARANTEE_RECORDING_ERROR",
  "GUARANTEE_RECORDING_ERROR_JBPM_PROCESS_STARTED",
  "GUARANTEE_RECORDING_ERROR_JBPM_PROCESS_STARTING",
  "GUARANTEE_RECTIFICATION",
  "GUARANTEE_RECTIFICATION_JBPM_PROCESS_STARTED",
  "GUARANTEE_RECTIFICATION_JBPM_PROCESS_STARTING",
  "PREPAYMENT",
  "PROLONGATION",
  "REFINANCE_AFTER_PAYMENT_GUARANTEE_MANAGEMENT",
  "REFINANCE_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTED",
  "REFINANCE_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTING",
  "REFINANCE_CUSTOMER_GROUP_RECORDING",
  "REFINANCE_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "REFINANCE_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTING",
  "RENEWAL",
  "REPAYMENT",
  "REPAYMENT_EXPIRED_LOAN",
  "UNDER_TERMINATION",
  "SZK_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTING",
  "SZK_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "SZK_CUSTOMER_GROUP_RECORDING",
  "SZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTING",
  "SZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTED",
  "SZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT",
  "SZK_REFINANCE_LOCK_RECORDING_ERROR_JBPM_PROCESS_STARTED",
  "SZK_REFINANCE_LOCK_RECORDING_ERROR",
  "SZK_REFINANCE_LOCK_APPROVAL_ERROR_JBPM_PROCESS_STARTING",
  "SZK_REFINANCE_LOCK_APPROVAL_ERROR_JBPM_PROCESS_STARTED",
  "SZK_REFINANCE_LOCK_APPROVAL_ERROR",
  "ASZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT",
  "ASZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTED",
  "ASZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTING",
  "ASZK_CUSTOMER_GROUP_RECORDING",
  "ASZK_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "ASZK_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTING",
  "BSZK_CUSTOMER_GROUP_RECORDING",
  "BSZK_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "BSZK_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTING",
  "SZK_ANNUAL_REVISION",
  "ASZK_RENEWAL",
  "SZK_RENEWAL",
  "SZK_FULFILMENT",
  "SZK_DATA_MODIFICATION",
  "ASZK_DATA_MODIFICATION",
  "BSZK_DATA_MODIFICATION",
  "SZK_UNDER_TERMINATION",
  "ASZK_UNDER_TERMINATION",
  "BSZK_UNDER_TERMINATION",
  "BSZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTING",
  "BSZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTED",
  "BSZK_AFTER_PAYMENT_GUARANTEE_MANAGEMENT",
  "PAL_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STATRING",
  "PAL_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "PAL_CUSTOMER_GROUP_RECORDING",
  "PAL_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTING",
  "PAL_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTED",
  "PAL_AFTER_PAYMENT_GUARANTEE_MANAGEMENT",
  "PAL_ANNUAL_REVISION",
  "BIA_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTING",
  "BIA_CUSTOMER_GROUP_RECORDING_JBPM_PROCESS_STARTED",
  "BIA_CUSTOMER_GROUP_RECORDING",
  "BIA_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTING",
  "BIA_AFTER_PAYMENT_GUARANTEE_MANAGEMENT_JBPM_PROCESS_STARTED",
  "BIA_AFTER_PAYMENT_GUARANTEE_MANAGEMENT",
]
